import React from 'react'
import { connect } from 'react-redux'
import Markup from 'components/Markup'

const mapStateToProps = ({ map: { markups }, createdAt }) => ({ markups, createdAt })

class MarkupsContainer extends React.Component {
  render() {
    const { props: { markups, map, mapContextMenuEventHandler, contextMenuOptions, createdAt } } = this
    return (
      <div>
        { map &&
          markups.map(m =>
            <Markup
              {...m}
              key={createdAt + m.id}
              map={map}
              mapContextMenuOptions={contextMenuOptions}
              mapContextMenuEventHandler={mapContextMenuEventHandler}
            />
          )
        }
      </div>
    )
  }
}

export default connect(mapStateToProps)(MarkupsContainer)



// WEBPACK FOOTER //
// ./src/components/MarkupsContainer/index.js